<script setup lang="ts">
import { StrapiBlocks, type BlocksContent } from 'vue-strapi-blocks-renderer'

defineProps<{
  content?: BlocksContent
  align?: 'left' | 'center' | 'right'
  clamp?: number
  customClass?: string
}>()
</script>

<template>
  <div
    v-if="content"
    class="flex flex-col strapi-block font-alexandria font-extralight"
    :class="[
      align === 'center' ? 'text-center' : '',
      align === 'right' ? 'text-right' : '',
      customClass,
    ]"
    :data-clamp="`${clamp}`"
  >
    <StrapiBlocks :class="clamp && clamp > 0 ? `line-clamp-${clamp}` : ''" :content="content" />
  </div>
</template>

<style>
/* Styling for the StrapiBlocks utility */
.strapi-block p + p {
  margin-top: 1.5rem;
}
.strapi-block ul {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-right: 0;
  list-style-image: url('../../../assets/rightArrow.svg');
  list-style-type: square;

  padding-left: 1.5rem;
}
.strapi-block ul + p {
  padding-left: 2rem;
}
.strapi-block li {
  padding-left: 0.5rem;
  padding-top: 1.5rem;
}
.strapi-block li::marker {
  font-size: 3rem; /* Adjust this value so that it appears what size you want. */
  line-height: 0;
}
.strapi-block h1 {
  font-size: 2rem;
}
.strapi-block h2 {
  font-size: 1.6rem;
}
.strapi-block h3 {
  font-size: 1.2rem;
}
.strapi-block[data-clamp='3'] p {
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}
</style>
